import Axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';

import ListSection from '../../Layout/ListSection/ListSection';
import RecommendedGroup from '../RecommendedGroup/RecommendedGroup';

import './RecommendedGroupsList.scss';

export default class RecommendedGroupsList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            recommendedGroups: [],
        };
    }

    static propTypes = {
        /**
         * array of recommended groups
         */
        recommendedGroups: PropTypes.array,
        /**
         * string of title
         */
        title: PropTypes.string,
        /**
         * links to groups open new tab
         */
        openLinksInNewTab: PropTypes.bool,
    };

    static defaultProps = {
        recommendedGroups: [],
        title: 'Recommended Groups For You',
        openLinksInNewTab: false,
    };

    async componentDidMount() {
        // @TODO: Adding this condition to refactor later on
        // And use elsewhere
        if (!this.props.recommendedGroups.length) {
            try {
                const response =
                    (await Axios.get(
                        '/api/network/group/recommended-groups?resultsPerPage=5'
                    )) || {};
                const { results } = response.data || {};

                this.setState({ recommendedGroups: results });
            } catch (e) {
                console.error(`Failed to fetch user's groups: `, e);
            }
        }
    }

    renderRecommendedGroup = (group, index) => {
        const { openLinksInNewTab } = this.props;
        return (
            <RecommendedGroup
                key={`recommended-group-${index}`}
                recommendedGroup={group}
                openLinksInNewTab={openLinksInNewTab}
            />
        );
    };

    render() {
        return (
            <div className="component-Groups-RecommendedGroupsList">
                <ListSection title={this.props.title}>
                    <ul>
                        {this.state.recommendedGroups.map(
                            this.renderRecommendedGroup
                        )}
                    </ul>
                </ListSection>
            </div>
        );
    }
}
